import { useContext, useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import './Home.css'; // Ensure this is the correct path to your CSS file
import axios from 'axios';
import BACKEND_URL from '../config'; // Ensure BACKEND_URL is correctly set up
import { LuPackageCheck } from "react-icons/lu";
import { LiaMapMarkedAltSolid } from "react-icons/lia";

const Home = () => {
    const navigate = useNavigate();
    const { loggedIn } = useContext(AuthContext);

    const [bookedShipments, setBookedShipments] = useState();
    const [shipmentsToBeBooked, setShipmentsToBeBooked] = useState();

    useEffect(() => {
        const fetchBookedShipments = async () => {
            try {
                const response = await axios.get(`${BACKEND_URL}/api/home`, {
                    withCredentials: true,
                });
                setBookedShipments(response.data.count || 0); // Use the 'count' field from the API response
                setShipmentsToBeBooked(response.data.quotes || 0); 
            } catch (error) {
                console.error('Error fetching booked shipments:', error);
                setBookedShipments(0); // Default to 0 on error
            }
        };
    
        fetchBookedShipments();
    }, []);
    

    const handleNavigation = (path) => {
        if (loggedIn) {
            navigate('/tms' + path);
        } else {
            navigate('/tms/login');
        }
    };

    return (
        <div className="dashboard-container">
            <h1>Welcome to Freight Ops TMS</h1>

            <div className="stats-row">
                <Card className="mb-3 stats-card">
                    <Card.Body>
                        <h2>Shipments Booked</h2>
                        <p><LuPackageCheck /> {bookedShipments}</p>
                    </Card.Body>
                </Card>
                <Card className="mb-3 stats-card">
                    <Card.Body>
                        <h2>Number of Quotes</h2>
                        <p><LiaMapMarkedAltSolid /> {shipmentsToBeBooked}</p>
                    </Card.Body>
                </Card>
            </div>

            <div className="info-row">
                <Card className="mb-3 info-card">
                    <Card.Body>
                        <div>
                            <h2>Manage Quotes</h2>
                            <Card.Text>
                                Create, view, and manage your transportation quotes effortlessly.
                            </Card.Text>
                        </div>
                        <button onClick={() => handleNavigation('/quotes')}>See Quotes</button>
                    </Card.Body>
                </Card>
                <Card className="mb-3 info-card">
                    <Card.Body>
                        <div>
                            <h2>Spot Quotes</h2>
                            <Card.Text>
                                Get instant spot quotes for your urgent transportation needs.
                            </Card.Text>
                        </div>
                        <button onClick={() => handleNavigation('/spot-quotes')}>Get Spot Quotes</button>
                    </Card.Body>
                </Card>
                <Card className="mb-3 info-card">
                    <Card.Body>
                        <div>
                            <h2>Contact Us</h2>
                            <Card.Text>
                                Reach out to us for any queries or support. We are here to help you.
                            </Card.Text>
                        </div>
                        <button onClick={() => handleNavigation('/contact')}>Contact Support</button>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
};

export default Home;
